/**
 * ServiceTypeBadge — toont een gekleurde badge per zending.service_type.
 * Gebruikt in Magazijn-overzicht, Zendingdetail, ConsolidationDetail
 * zendingen-tabel en Tracking & Labels lijst.
 */
import React from "react";
import { Plane, Anchor, Truck, Bike, ShoppingBag, Store, Package } from "lucide-react";

const SERVICE_TYPE_META = {
  airfreight:    { label: "Luchtvracht",    cls: "bg-sky-100 text-sky-900 border-sky-300",       icon: Plane },
  seafreight:    { label: "Zeevracht",      cls: "bg-cyan-100 text-cyan-900 border-cyan-300",    icon: Anchor },
  ground:        { label: "Ground",         cls: "bg-slate-100 text-slate-800 border-slate-300", icon: Truck },
  courier:       { label: "Courier",        cls: "bg-purple-100 text-purple-900 border-purple-300", icon: Bike },
  shopdrop_ship: { label: "ShopDrop&Ship",  cls: "bg-amber-100 text-amber-900 border-amber-300", icon: ShoppingBag },
  counter_sale:  { label: "Balieverkoop",   cls: "bg-indigo-100 text-indigo-900 border-indigo-300", icon: Store },
  package:       { label: "Pakket",         cls: "bg-gray-100 text-gray-800 border-gray-300",    icon: Package },
  warehouse:     { label: "Magazijn",       cls: "bg-amber-100 text-amber-900 border-amber-300", icon: Package },
};

export default function ServiceTypeBadge({ serviceType, size = "sm", showIcon = true, testId }) {
  const key = (serviceType || "").toLowerCase();
  const meta = SERVICE_TYPE_META[key] || { label: serviceType || "Onbekend", cls: "bg-gray-100 text-gray-700 border-gray-300", icon: Package };
  const Icon = meta.icon;
  const sizeCls = size === "lg"
    ? "px-2.5 py-1 text-xs"
    : "px-2 py-0.5 text-[10px]";
  return (
    <span
      className={`inline-flex items-center gap-1 font-bold uppercase tracking-wide border ${meta.cls} ${sizeCls}`}
      data-testid={testId || `service-type-badge-${key}`}
      title={meta.label}
    >
      {showIcon && <Icon className="w-3 h-3" />}
      {meta.label}
    </span>
  );
}

export { SERVICE_TYPE_META };
